import axiosPrivate from "../../../api/axiosPrivate";
import {
  ADD_COINSURANCE,
  GET_ALL_COINSURANCE,
  GET_SINGLE_COINSURANCE,
  UPDATE_COINSURANCE,
} from "../../../api/constant";

const addCoinsurance = async (data) => {
  const response = await axiosPrivate.post(`${ADD_COINSURANCE}`, data);
  return response.data;
};

//get all coinsurance
const getAllCoinsurace = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_COINSURANCE}?page=${data?.pageNumber}`
  );

  return response.data;
};

// get single coinsurance

const getSingleCoinsurance = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_COINSURANCE}/${id}`);
  return response.data;
};

//update single single  coinsurance
const updateSingleCoinsurance = async (payload) => {
  const response = await axiosPrivate.patch(
    `${UPDATE_COINSURANCE}/${payload.id}`,
    payload.data
  );
  return response.data;
};

const coinsuranceService = {
  addCoinsurance,
  getAllCoinsurace,
  getSingleCoinsurance,
  updateSingleCoinsurance,
};

export default coinsuranceService;
